/* ZenaJade Atelier theme JS */
(function () {
  'use strict';

  /* ---- Homepage / collection tab filter ---- */
  function initTabs() {
    var tabWraps = document.querySelectorAll('[data-tabs]');
    tabWraps.forEach(function (wrap) {
      var gridId = wrap.getAttribute('data-tabs');
      var grid = document.getElementById(gridId);
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
      var note = document.getElementById(gridId + '-note');
      var tabs = wrap.querySelectorAll('.tab');

      function apply(filter) {
        var n = 0;
        cards.forEach(function (c) {
          var show = filter === 'All' || c.dataset.cat === filter;
          c.style.display = show ? '' : 'none';
          if (show) n++;
        });
        if (note) note.textContent = filter === 'All' ? n + ' pieces' : n + ' ' + filter.toLowerCase();
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          apply(t.dataset.filter);
        });
      });
      apply('All');
    });
  }

  /* ---- Product gallery thumbnails ---- */
  function initGallery() {
    var main = document.getElementById('pdpMain');
    if (!main) return;
    var thumbs = document.querySelectorAll('.pdp__thumbs button');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-full');
        if (src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
      });
    });
  }

  /* ---- Product variant selection ---- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var data = document.getElementById('product-variants-json');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[name="id"]');
    var priceNow = document.querySelector('[data-price-now]');
    var addBtn = form.querySelector('[data-add-btn]');

    function current() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.dataset.optionIndex, 10)] = s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function update() {
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = v.price;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.sold;
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTabs();
    initGallery();
    initVariants();
  });
})();
